module.exports = __webpack_public_path__ + "media/mabani/mabani-slide4-59aaac85.jpg";